import { mutate } from 'swr'

import { useHandleAxiosError } from '@/hooks/common/useHandleAxiosError'
import {
  getNotificationsReleasesUnreadListKey,
  notificationsReleasesReadCreate,
  useNotificationsReleasesList,
} from '@api'
import { Release } from '@api/models'

export const useRelease = () => {
  const { handleAxiosError } = useHandleAxiosError()
  const { data: releaseList, mutate: refetch } = useNotificationsReleasesList()
  const unreadReleaseListKey = getNotificationsReleasesUnreadListKey()

  const readRelease = async (releaseId: number, onSuccess?: () => void) => {
    try {
      await notificationsReleasesReadCreate(String(releaseId))
      refetch()
      mutate(unreadReleaseListKey)
      onSuccess?.()
    } catch (error) {
      handleAxiosError(error)
    }
  }

  /**
   * リリースを選択したときの処理
   * 既読処理を行う
   * @param item 選択されたリリース
   * @param openDetail 詳細ダイアログを開く関数
   */
  const onSelect =
    (item: Release, openDetail: (item: Release) => void) => () => {
      openDetail(item)
      readRelease(item.id)
    }

  return { releaseList: releaseList ?? [], onSelect }
}
